import SlideButtonsGroup from './SlideButtonsGroup';

export default SlideButtonsGroup;
